import {Box, Text} from '@mantine/core';
import Image from 'next/image';
import type {FC} from 'react';
import {MdArrowForwardIos} from 'react-icons/md';
import PROMPT_TO_ADD_SCHEDULE from '../../../../../public/next-image/box/banner/calendar_button.png';
import type {GetMyCalendarType} from '../../../../core/entities/calendar/schema';
import {cn} from '../../../../lib/classname';
import {CalendarScheduleList} from './CalendarScheduleList';

type Props = {
  userName?: string;
  calendarData?: GetMyCalendarType;
  isError: boolean;
  onAddSchedule: () => void;
  className?: string;
};

export const RightSideCalendarPresentation: FC<Props> = ({
  userName,
  calendarData,
  isError,
  onAddSchedule,
  className,
}) => {
  return (
    <Box className={cn('w-full flex flex-col shadow-card', className)}>
      <Box className="flex justify-between bg-primary-1 px-12 py-8 ">
        <Text className="mb-2 font-bold text-white text-base">
          {userName}さんのスケジュール
        </Text>
        <button
          type="button"
          className="bg-white px-8 py-0 group rounded-4 pc:hover:border-primary-2 pc:hover:ease-in-out pc:hover:duration-300"
          style={{lineHeight: 1}}
          onClick={onAddSchedule}
        >
          <span
            className="text-xs text-primary pc:group-hover:text-primary-2 pc:hover:ease-in-out pc:hover:duration-300"
            style={{lineHeight: 1}}
          >
            予定を追加
          </span>
        </button>
      </Box>
      <Box>
        <Box className="p-12 flex flex-col gap-y-4 items-start bg-white">
          {!isError && calendarData ? (
            <CalendarScheduleList calendarData={calendarData} />
          ) : (
            <Image
              src={PROMPT_TO_ADD_SCHEDULE}
              alt="締め切りのカレンダー登録でエントリー忘れを防ぎましょう"
            />
          )}
        </Box>
        <a href="/schedule">
          <Text className="mb-2 bg-background-2 px-12 py-8 text-primary-2 text-[13px] flex items-center justify-center">
            <MdArrowForwardIos />
            すべての予定をスケジュールで見る
          </Text>
        </a>
      </Box>
    </Box>
  );
};
